import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase.js'

const LS_KEY="estoqueos_eventlog";
const MAX_EVENTS=2000;

function loadEvLog(){
  try{const raw=localStorage.getItem(LS_KEY);if(raw){const parsed=JSON.parse(raw);if(Array.isArray(parsed))return parsed;}}catch(e){}
  return[];
}
function saveEvLog(list){
  try{localStorage.setItem(LS_KEY,JSON.stringify(list.slice(0,MAX_EVENTS)));}catch(e){}
}

async function sbLoadEvLog(){
  const{data,error}=await supabase.from('auditoria').select('*').order('timestamp',{ascending:false}).limit(MAX_EVENTS);
  if(error||!data)return null;
  return data.map(r=>({...r,id:r.id,id_entidade:r.id_entidade??''}));
}
async function sbInsertEvent(ev){
  const{error}=await supabase.from('auditoria').insert({
    id:String(ev.id),
    tipo_evento:ev.tipo_evento,
    usuario:ev.usuario,
    entidade:ev.entidade,
    id_entidade:ev.id_entidade,
    detalhes:ev.detalhes??'',
    timestamp:ev.timestamp,
  });
  if(error)console.warn('supabase eventlog insert error',error);
}

let _evLog=loadEvLog();
let _evll=[];
let _evReady=false;

function subEvLog(fn){_evll.push(fn);return()=>{_evll=_evll.filter(f=>f!==fn);};}

function setGlobalEvLog(fn){
  _evLog=fn(_evLog);
  saveEvLog(_evLog);
  _evll.forEach(f=>f(_evLog));
}

async function initEvLog(){
  if(_evReady)return;
  _evReady=true;
  const remote=await sbLoadEvLog();
  if(remote&&remote.length>0){
    _evLog=remote;
    saveEvLog(_evLog);
    _evll.forEach(f=>f(_evLog));
  }
}

function useGlobalEvLog(){
  const[ev,sEv]=useState(()=>_evLog);
  useEffect(()=>{
    sEv(_evLog);
    const unsub=subEvLog(sEv);
    initEvLog();
    return unsub;
  },[]);
  return[ev,setGlobalEvLog];
}

function logEvent({tipo_evento,usuario,entidade,id_entidade,detalhes=""}){
  const ev={
    id:crypto.randomUUID(),
    tipo_evento,usuario,entidade,
    id_entidade:String(id_entidade),
    detalhes,
    timestamp:new Date().toISOString()
  };
  setGlobalEvLog(prev=>[ev,...prev]);
  sbInsertEvent(ev);
}

export { useGlobalEvLog, setGlobalEvLog, logEvent }